import { ComponentProps } from 'react';
import { bordColorTheme } from '../../../../styles/styles.constants';

/**
 * Icono de documento para el sistema de iconos de Bord
 * @param props - Propiedades del componente SVG
 * @returns Componente del icono de documento
 */
const BordDocumentIcon = (props: ComponentProps<'svg'>) => {
  const { stroke } = props;
  return (
    <svg viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_21460_23)">
        <path
          d="M8.83829 7.91707C8.89736 6.97555 8.92843 5.99985 8.92843 5.00007C8.92843 4.59516 8.92336 4.19419 8.91336 3.79784C8.90636 3.51941 8.816 3.24881 8.65122 3.02428C8.023 2.16848 7.52258 1.63644 6.69779 0.999905C6.47114 0.824977 6.19301 0.73007 5.90678 0.723813C5.61976 0.717541 5.32004 0.714355 4.99986 0.714355C4.03061 0.714355 3.24875 0.743548 2.43965 0.799177C1.75133 0.846505 1.20467 1.39446 1.16145 2.08304C1.10235 3.02459 1.07129 4.00029 1.07129 5.00007C1.07129 5.99985 1.10235 6.97555 1.16145 7.91707C1.20467 8.60571 1.75133 9.15364 2.43965 9.20093C3.24875 9.25657 4.03061 9.28578 4.99986 9.28578C5.96911 9.28578 6.75097 9.25657 7.56008 9.20093C8.24836 9.15364 8.79508 8.60571 8.83829 7.91707Z"
          fill="white"
          stroke={stroke || bordColorTheme.navyBlue[400]}
        />
        <path
          d="M3.63867 5.01095H6.36189M3.63867 7.08683H6.35342M3.63867 2.85693H5.28199"
          stroke={stroke || bordColorTheme.navyBlue[400]}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_21460_23">
          <rect width="10" height="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BordDocumentIcon;
